const createURLParams = (params: Record<string, string | number | boolean | undefined>) => {
	const urlParams = new URLSearchParams();

	Object.entries(params).forEach(([key, value]) => {
		if (typeof value !== 'undefined') {
			urlParams.append(key, value.toString());
		}
	});

	return urlParams;
};

export default createURLParams;
